module.exports = {"top3":["Home health patients with a hospital admission","Adults who have lost six or more teeth","Adults who smoke"],"bottom3":["Children without a medical home","Adults with any mental illness who did not receive treatment","Children without all recommended vaccines"],"most_improved":["Uninsured adults","Uninsured children","Home health patients without improved mobility"],"most_declined":["Children who did not receive needed mental health care","Hospital 30-day readmission rate ages 18-64","Preventable hospitalizations ages 18-64"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/highlights/CA.json
// module id = 244
// module chunks = 143196823979170 184088790168614